import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
  text-align: center;
  font-size: 16px;
  color: ${props => props.theme.primary}
  margin-top: 50px;
`;

const PageIndicator = ({ current, total }) => (
  <Div>{`${current}/${total}`}</Div>
);

export default PageIndicator;
